import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ButtonSt from "../../../components/ButtonSt";

import NotEligibleIcon from "../../../assets/images/return-on-investment.svg";

import { NoEligibleWrapper } from "./style";

import { SetAuthState } from "../../../redux/slices/auth-slice";
import { SetStoreState } from "../../../redux/slices/store-slice";
import { SetState } from "../../../redux/slices/account-detail-slice";

const NoEligible = ({ setStep }) => {
  const dispatch = useDispatch();
  const { storesCount } = useSelector((state) => state.auth);

  const clearStates = () => {
    dispatch(SetAuthState({ field: 'storeStatus', value: 'Initial' }))
    dispatch(SetAuthState({ field: 'storeId', value: '' }))
    dispatch(SetStoreState({ field: 'store', value: {} }))
    dispatch(SetStoreState({ field: 'storeId', value: '' }))
    dispatch(SetState({ field: 'account', value: {} }))
    setStep(0);
  }

  return (
    <NoEligibleWrapper>
      <div className="card_ui_overlay">
        <div className="card_ui_wrapper">
          <img src={NotEligibleIcon} />
          <h4>No Eligible Cases Identified</h4>
          <p>
            After reviewing your account, there is no eligible data for
            reimbursements currently. We are actively monitoring for new
            opportunities and will reach out when we find any data. Consider
            adding another store or marketplace:
          </p>
          <ButtonSt onClick={clearStates} outline >Add Another Store</ButtonSt>
        </div>
      </div>
    </NoEligibleWrapper>
  );
};

export default NoEligible;
